import type { IDisposable } from './IDisposable';

export interface IRegistry<TKey, TValue> {
  set: (key: TKey, value: TValue) => void;
  remove: (key: TKey) => void;
}

export class DisposablesRegistry<TKey> implements IRegistry<TKey, IDisposable>, IDisposable {
  private readonly _disposables = new Map<TKey, IDisposable>();

  // IDisposablesRegistry
  public set(key: TKey, disposables: IDisposable): void {
    if (this._disposables.has(key)) {
      throw new Error(`DisposablesRegistry: key already exists`);
    }
    this._disposables.set(key, disposables);
  }

  public remove(key: TKey): void {
    this._disposables.delete(key);
  }

  // IDisposable
  public dispose(): void {
    for (const disposable of this._disposables.values()) {
      disposable.dispose();
    }
    this._disposables.clear();
  }
}
